<template>
    <AppModal ref="modalRef" id="patient-update-modal" size="lg">
        <template #header>
            <h2>{{ patient.id ? 'Update' : 'Add' }} Patient</h2>
        </template>

        <PatientForm :patient="patient" id="patient-update-form" @form-submit="doSubmit" />

        <Debug>{{patient}}</Debug>

        <template #footer>
            <button type="button" class="btn btn-white"  @click="closeModal">Close</button>
            <AppButton type="submit" form="patient-update-form" class="btn btn-primary" :is-loading="isLoading">
                Save changes
            </AppButton>
        </template>
    </AppModal>
</template>

<script setup>
import { Debug } from "../../helpers";
import PatientForm from "./forms/PatientForm.vue";
import AppModal from "../../shared/AppModal.vue";
import { ref } from "vue";
import AppButton from "../../shared/AppButton.vue";
import { toast } from 'vue3-toastify';
import { Patient } from "../../helpers";

const props = defineProps({
    patient: {
        type: Object,
        default: null,
    },
});

const modalRef = ref(null);

const patient = ref(props.patient || Patient())

const isLoading = ref(false);

const doSubmit = async () => {
    isLoading.value = true;
    try {
        if (patient.value.id) {
            await axios.patch(`/api/patients/${patient.value.id}`, patient.value);
            toast.success("Patient was successfully updated!");
        } else {
            await axios.post(`/api/patients`, patient.value);
            toast.success("Patient was successfully created!");
        }
    } catch (e) {
        toast.error("Something was wrong");
    } finally {
        isLoading.value = false;
    }
};

const closeModal = () => {
    modalRef.value.closeModal();
}
</script>
